"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1272],{

/***/ 326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');

exports.Z = _default;

/***/ }),

/***/ 7136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _base_WebpImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76445);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	.h-logo-wrap-div {\n		display: flex;\n		flex-direction: row;\n		align-items: center;\n	}\n\n	.h-logo-wrap img {\n		height: 25px;\n	}\n\n	.shortconsulting-box {\n		margin-left: 12px;\n		display: inline-flex;\n		flex-direction: row;\n		align-items: center;\n		justify-content: center;\n	}\n\n	.shortconsulting {\n		position: relative;\n	}\n\n	.beta {\n		background-color: var(--primary);\n		padding: 3px 8px;\n		border-radius: 20px;\n		display: flex;\n		width: fit-content;\n		flex-direction: row;\n		align-items: center;\n		justify-content: center;\n		margin-left: 5px;\n		margin-right: 17px;\n		position: absolute;\n		right: -20px;\n		top: -20px;\n\n		div {\n			font-weight: bold;\n			color: white;\n			font-size: 10px;\n			line-height: 10px;\n			text-align: center;\n		}\n	}\n\n	@media (max-width: 975px) {\n		.h-logo-wrap img {\n			height: 20px;\n		}\n\n		.h-logo-wrap {\n			height: fit-content;\n			display: block;\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Logo = function(param) {
    var _pro = param.pro, pro = _pro === void 0 ? false : _pro;
    var logo = pro ? "/onepoint/assets/images/logo/h-logo_bl.png" : "/onepoint/assets/images/logo/h-logo.png";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LogoContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "h-logo-wrap-div",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "h-logo-wrap",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                    href: "/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        src: logo,
                        alt: "logo"
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Logo);
var LogoContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());


/***/ }),

/***/ 40191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ MainFooterMobile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61225);
/* harmony import */ var _src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76445);
/* harmony import */ var _src_ruix__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9869);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 20px;\n\n	picture {\n		width: 70px;\n\n		img {\n			width: 100%;\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: #808da3;\n	font-size: 10px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 120%; /* 12px */\n	letter-spacing: -0.4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: #fff;\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 120%; /* 28.8px */\n	letter-spacing: -0.96px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: #fff;\n	font-size: 12px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 120%; /* 14.4px */\n	letter-spacing: -0.48px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	background-color: var(--card-bg);\n	padding-top: 40px;\n	padding-left: 24px;\n	padding-right: 24px;\n	padding-bottom: 160px;\n	gap: 40px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var MainFooterMobile = function() {
    var a = 1;
    var isTablet = (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("(min-width: 500px)");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainFooterContainer, {
        className: "center-center-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "column-start-start",
            style: {
                width: "100%",
                maxWidth: "944px",
                gap: "32px"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                    order: isTablet ? "row-center-between" : "column-start-center",
                    fullWidth: true,
                    gap: 40,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                            order: "column-start-start",
                            gap: 10,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterTitle, {
                                    children: "주식회사 롸잇"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                    children: "탑티어 마케터 파트타임 고용 서비스"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                            order: "row-start-between",
                            gap: 32,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                                    order: "column-start-start",
                                    gap: 20,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterInfoTitle, {
                                            children: "COMPANY INFO"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                                            order: "column-start-start",
                                            gap: 8,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "대표자 | 최준순"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "주소 | 서울특별시 강남구 테헤란로26길 14, 위워크빌딩 10층 10-102호"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "이메일 | hello@1point.kr"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                                    order: "column-start-start",
                                    gap: 20,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterInfoTitle, {
                                            children: "BUSINESS INFO"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                                            order: "column-start-start",
                                            gap: 8,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "사업자등록번호 | 466-87-02214"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "통신판매업신고 | 2023-서울마포-0818"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "개인정보관리책임자 | 강용진"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                    order: "column-start-start",
                    gap: 10,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterInfoTitle, {
                            children: "Backed by"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(BackedByBox, {
                            className: "row-center-start",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    src: "/onepoint/images/invest/mashup_white.png",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    src: "/onepoint/images/invest/sopoong_white.png",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    src: "/onepoint/images/invest/tips_logo.png",
                                    alt: ""
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var BackedByBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
var FooterInfoTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject1());
var FooterTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2());
var FooterSubTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject3());
var MainFooterContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject4());


/***/ }),

/***/ 43775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ MainGnbMobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var Menu = __webpack_require__(326);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 1 modules
var Button = __webpack_require__(54225);
// EXTERNAL MODULE: ./src/component/base/WebpImage.tsx
var WebpImage = __webpack_require__(76445);
// EXTERNAL MODULE: ./src/hook/useUser.ts + 1 modules
var useUser = __webpack_require__(92859);
// EXTERNAL MODULE: ./src/ruix/index.ts + 22 modules
var ruix = __webpack_require__(9869);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var dist = __webpack_require__(1785);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/component/home/Logo.tsx
var Logo = __webpack_require__(7136);
// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MarketingMenuBoardModal.tsx
var MarketingMenuBoardModal = __webpack_require__(4547);
// EXTERNAL MODULE: ./src/api/index.ts + 2 modules
var api = __webpack_require__(53249);
;// CONCATENATED MODULE: ./src/component/home/renewal/main/mobile/MainMobileMenu.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	.mobile-background {\n		background-color: white;\n		display: flex;\n		flex-direction: column;\n		width: 100%;\n		top: 0;\n		bottom: 0;\n		left: 0;\n		position: fixed;\n		z-index: 10002;\n		overflow-y: auto;\n	}\n\n	.btn-login {\n		display: flex;\n		flex-direction: row;\n		align-items: center;\n		justify-content: center;\n		width: 150px;\n		height: 40px;\n		border-radius: 50px;\n		background: var(--primary);\n		transition: all 0.2s ease-in-out;\n		cursor: pointer;\n\n		&:hover {\n			transform: scale(1.05);\n		}\n\n		button {\n			font-size: 12px;\n			font-weight: 700;\n			color: #fff;\n		}\n	}\n\n	.mobile-expert .mobile-background {\n		background-color: white;\n	}\n\n	.hm-hidden {\n		display: none;\n	}\n\n	.mobile-background .head {\n		height: 75px;\n		padding: 0 5%;\n		display: flex;\n		justify-content: space-between;\n		align-items: center;\n		width: 100%;\n		position: fixed;\n		z-index: 1000;\n		top: 0;\n		left: 0;\n	}\n\n	.mobile-background .head {\n		display: flex;\n		flex-direction: row;\n		align-items: center;\n		margin-bottom: 100px;\n	}\n\n	.h-close-wrap img {\n		width: 24px;\n		height: 24px;\n	}\n\n	.hm-menu {\n		margin-top: 75px;\n		display: flex;\n		flex-direction: column;\n		align-items: end;\n		gap: 15px;\n		padding: 0 5%;\n	}\n\n	.hm-menu a {\n		color: var(--card-bg);\n		font-size: 20px;\n		font-weight: bold;\n		font-family: "pretendard" !important;\n		position: relative;\n\n		.beta {\n			position: absolute;\n			top: 50%;\n			left: -55px;\n			transform: translateY(-50%);\n			background-color: var(--primary);\n			padding: 1px 8px;\n			border-radius: 20px;\n			display: flex;\n			flex-direction: row;\n			align-items: center;\n			justify-content: center;\n			margin-left: 3px;\n			div {\n				font-weight: bold;\n				color: white;\n				font-size: 14px;\n				line-height: 20px;\n				text-align: center;\n			}\n		}\n	}\n\n	.mobile-expert .hm-menu a {\n		color: var(--card-bg);\n	}\n\n	button {\n		border: none;\n		background: transparent;\n	}\n\n	.hm-menu .h-link a button {\n		border-radius: 25px;\n		color: var(--card-bg);\n		border: 1px solid var(--card-bg);\n		width: 150px;\n		height: 40px;\n		font-size: 12px;\n		font-weight: 500;\n	}\n\n	.mobile-expert .hm-menu .h-link a button {\n		color: var(--card-bg);\n		border: 1px solid #000;\n	}\n\n	.shortconsulting-box {\n		display: inline-flex;\n		flex-direction: row;\n		align-items: center;\n		justify-content: center;\n	}\n\n	.shortconsulting {\n		margin-left: 10px;\n		position: relative;\n	}\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var MainMobileMenu = function(param) {
    var _hidden = param.hidden, hidden = _hidden === void 0 ? true : _hidden, _pro = param.pro, pro = _pro === void 0 ? false : _pro, onClose = param.onClose;
    var closeIcon = "/onepoint/assets/images/icon/close_pro.png";
    var router = (0,next_router.useRouter)();
    var user = (0,useUser/* default */.Z)().user;
    var ref = (0,react.useState)(false), menuBoardOpen = ref[0], setMenuBoardOpen = ref[1];
    var onClickLogin = function() {
        if (pro) {
            router.push("/signin?type=expert");
        } else {
            router.push("/signin?type=client");
        }
    };
    var onClickDashboard = function() {
        router.push("/match/my");
    };
    var onClickMenuBoard = function() {
        if (user.isLogin) {
            api/* apiServiceV2.post */.sl.post("/utils/click-menu-board").catch(function(err) {
                return console.error(err);
            });
            window.open("https://shrouded-meal-521.notion.site/2aff8567bbfa8029809bc906e4277307?v=2aff8567bbfa80218222000cad0af51c", "_blank");
        } else {
            setMenuBoardOpen(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileMenuWrapper, {
        style: {
            height: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-menu-tab ".concat(pro ? "mobile-expert" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mobile-background ".concat(hidden ? "hm-hidden" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "head",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                    pro: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-close-wrap",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "menu-icon mob-menu-btn",
                                        src: closeIcon,
                                        alt: "logo",
                                        onClick: onClose
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hm-menu",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://featpaper.com/l/JemyuEY9",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    onClick: function() {
                                        var tagManagerArgs = {
                                            dataLayer: {
                                                event: "client-menu-click",
                                                to: "guide"
                                            }
                                        };
                                        dist_default().dataLayer(tagManagerArgs);
                                    },
                                    children: "서비스 소개"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://1point.kr/blog",
                                    onClick: function() {
                                        var tagManagerArgs = {
                                            dataLayer: {
                                                event: "client-menu-click",
                                                to: "blog"
                                            }
                                        };
                                        dist_default().dataLayer(tagManagerArgs);
                                    },
                                    children: "블로그"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://1point.kr/blog/best-practices/",
                                    onClick: function() {
                                        var tagManagerArgs = {
                                            dataLayer: {
                                                event: "client-menu-click",
                                                to: "best-practices"
                                            }
                                        };
                                        dist_default().dataLayer(tagManagerArgs);
                                    },
                                    children: "성공 사례"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/about",
                                    children: "회사 소개"
                                }),
                                !pro && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-link client",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        style: {
                                            width: "fit-content",
                                            padding: "0 15px",
                                            backgroundColor: "#3D4148",
                                            color: "#fff",
                                            fontWeight: 800,
                                            fontSize: "12px",
                                            borderRadius: "25px",
                                            height: "40px",
                                            transition: "all 0.2s ease-in-out",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "6px",
                                            border: "none",
                                            whiteSpace: "nowrap"
                                        },
                                        onClick: onClickMenuBoard,
                                        children: [
                                            "마케팅 메뉴판 확인하기",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    backgroundColor: "#387cf6",
                                                    color: "white",
                                                    fontSize: "8px",
                                                    fontWeight: 900,
                                                    padding: "2px 4px",
                                                    borderRadius: "4px",
                                                    lineHeight: "1"
                                                },
                                                children: "NEW"
                                            })
                                        ]
                                    })
                                }),
                                !pro && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-link client",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://notion.1point.kr/agency-matching",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            style: {
                                                width: "fit-content",
                                                padding: "0 15px",
                                                backgroundColor: "#fff",
                                                color: "#000",
                                                fontWeight: 800,
                                                borderRadius: "25px",
                                                height: "40px",
                                                transition: "all 0.2s ease-in-out",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px"
                                            },
                                            onMouseOver: function(e) {
                                                return e.currentTarget.style.backgroundColor = "#f0f5ff";
                                            },
                                            onMouseOut: function(e) {
                                                return e.currentTarget.style.backgroundColor = "#fff";
                                            },
                                            children: [
                                                "탑티어 ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "#387cf6"
                                                    },
                                                    children: "대행사"
                                                }),
                                                " ",
                                                "매칭받기",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        backgroundColor: "#387cf6",
                                                        padding: "2px 4px",
                                                        borderRadius: "4px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginLeft: "2px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            fontWeight: "bold",
                                                            color: "white",
                                                            fontSize: "8px",
                                                            lineHeight: "8px"
                                                        },
                                                        children: "BETA"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                user.isLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "btn-login",
                                    onClick: onClickDashboard,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        children: "대시보드"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "btn-login",
                                    onClick: onClickLogin,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        children: "로그인하기"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-link client",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: pro ? "/" : "/expert",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            children: pro ? "고객사이신가요?" : "전문가이신가요?"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingMenuBoardModal/* MarketingMenuBoardModal */.a, {
                open: menuBoardOpen,
                onClose: function() {
                    return setMenuBoardOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var mobile_MainMobileMenu = (MainMobileMenu);
var MobileMenuWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());

;// CONCATENATED MODULE: ./src/component/home/renewal/main/mobile/MainGnbMobile.tsx

function MainGnbMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	background-color: var(--primary);\n	padding: 6px;\n	position: sticky;\n	top: 60px;\n	z-index: 10000;\n	cursor: pointer;\n\n	.text {\n		color: white;\n		font-size: 14px;\n		font-weight: 800;\n	}\n"
    ]);
    MainGnbMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	min-width: fit-content;\n	width: fit-content;\n	padding: 0;\n	color: #fff;\n	text-align: center;\n	font-family: Pretendard;\n	font-size: 14px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 130%; /* 18.2px */\n	letter-spacing: -0.42px;\n	position: relative;\n\n	.beta {\n		background-color: var(--primary);\n		padding: 3px 8px;\n		border-radius: 20px;\n		display: flex;\n		flex-direction: row;\n		align-items: center;\n		justify-content: center;\n		margin-left: 5px;\n		margin-right: 0px;\n\n		div {\n			font-weight: bold;\n			color: white;\n			font-size: 10px;\n			line-height: 10px;\n			text-align: center;\n		}\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 4px 8px;\n	height: auto;\n	width: 50px;\n	min-width: 50px;\n	font-weight: bold;\n	font-size: 12px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 130%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	min-height: 48px;\n	padding: 6px 12px;\n	position: sticky;\n	background-color: var(--card-bg);\n	gap: 10px;\n	top: 0;\n	z-index: 10000;\n\n	picture {\n		display: flex;\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











var MainGnbMobile = function(props) {
    var type = props.type, noBanner = props.noBanner;
    var user = (0,useUser/* default */.Z)().user;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(true), hideMobileMenu = ref[0], setHideMobileMenu = ref[1];
    var handleOnClickMenu = function() {
        setHideMobileMenu(!hideMobileMenu);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_MainMobileMenu, {
                pro: type === "expert" ? true : false,
                hidden: hideMobileMenu,
                onClose: handleOnClickMenu
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainGnbContainer, {
                className: "row-center-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row-center-between",
                    style: {
                        width: "100%",
                        maxWidth: "944px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                            order: "row-center-between",
                            gap: 10,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                                    style: {
                                        width: "110px",
                                        marginRight: "32px"
                                    },
                                    src: "/onepoint/assets/images/logo/h-logo.png"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                            order: "row-center-between",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                size: "large",
                                edge: "start",
                                color: "inherit",
                                "aria-label": "menu",
                                onClick: handleOnClickMenu,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                                    sx: {
                                        fill: "white"
                                    }
                                })
                            })
                        })
                    ]
                })
            }),
            type === "client" && !noBanner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner, {
                className: "row-center-between",
                id: "banner-close",
                onClick: function() {
                    window.open("https://docs.channel.io/onepoint/ko/articles/1286c10a-%EB%A6%AC%EC%8A%A4%ED%81%AC%ED%94%84%EB%A6%AC-%EC%A0%95%EC%B1%85-%EC%95%88%EB%82%B4");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text",
                        children: [
                            "\uD83C\uDF89리스크프리 프로그램!",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    fontWeight: 800
                                },
                                children: "전문가 불만족시 100% 환불!"
                            }),
                            "✨"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                        style: {
                            fill: "white",
                            cursor: "pointer",
                            width: "20px",
                            height: "20px"
                        },
                        onClick: function(e) {
                            e.stopPropagation();
                            document.getElementById("banner-close").style.display = "none";
                        }
                    })
                ]
            }) : null
        ]
    });
};
var Banner = emotion_styled_browser_esm/* default.div */.Z.div(MainGnbMobile_templateObject());
var GnbMenuButton = (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z)(_templateObject1());
var GnbButton = (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z)(_templateObject2());
var MainGnbContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());


/***/ }),

/***/ 62579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ MainFooter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76445);
/* harmony import */ var _src_ruix__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9869);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 20px;\n\n	picture {\n		width: 100px;\n\n		img {\n			width: 100%;\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: #808da3;\n	font-size: 10px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 120%; /* 12px */\n	letter-spacing: -0.4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: #fff;\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 120%; /* 28.8px */\n	letter-spacing: -0.96px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: #fff;\n	font-size: 12px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 120%; /* 14.4px */\n	letter-spacing: -0.48px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	min-height: 320px;\n	background-color: var(--card-bg);\n	padding-top: 40px;\n	padding-left: 24px;\n	padding-right: 24px;\n	gap: 40px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var MainFooter = function() {
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainFooterContainer, {
        className: "row-center-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "column-start-start",
            style: {
                width: "100%",
                maxWidth: "944px"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                    order: "row-start-between",
                    fullWidth: true,
                    gap: 40,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                            order: "column-start-start",
                            gap: 10,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterTitle, {
                                    children: "주식회사 롸잇"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                    children: "탑티어 마케터 파트타임 고용 서비스"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                            order: "row-start-between",
                            gap: 48,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                                    order: "column-start-start",
                                    gap: 20,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterInfoTitle, {
                                            children: "COMPANY INFO"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                                            order: "column-start-start",
                                            gap: 8,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "대표자 | 최준순"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "주소 | 서울특별시 강남구 테헤란로26길 14, 위워크빌딩 10층 10-102호"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "이메일 | hello@1point.kr"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                                    order: "column-start-start",
                                    gap: 20,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterInfoTitle, {
                                            children: "BUSINESS INFO"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                                            order: "column-start-start",
                                            gap: 8,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "사업자등록번호 | 466-87-02214"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "통신판매업신고 | 2023-서울마포-0818"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterSubTitle, {
                                                    children: "개인정보관리책임자 | 강용진"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                    order: "column-start-start",
                    gap: 20,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterInfoTitle, {
                            children: "Backed by"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(BackedByBox, {
                            className: "row-center-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    src: "/onepoint/images/invest/mashup_white.png",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    src: "/onepoint/images/invest/sopoong_white.png",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    src: "/onepoint/images/invest/tips_logo.png",
                                    alt: ""
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var BackedByBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
var FooterInfoTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject1());
var FooterTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2());
var FooterSubTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject3());
var MainFooterContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject4());


/***/ }),

/***/ 9561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ MainGnb; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70917);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50594);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54225);
/* harmony import */ var _src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76445);
/* harmony import */ var _src_hook_useUser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92859);
/* harmony import */ var _src_ruix__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9869);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var _MarketingMenuBoardModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4547);
/* harmony import */ var _src_api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53249);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 4px 8px;\n	height: auto;\n	width: auto;\n	min-width: fit-content;\n	font-weight: bold;\n	font-size: 12px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 130%;\n	white-space: nowrap;\n	transition: all 0.2s ease-in-out;\n	&:hover {\n		transform: scale(1.05);\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	background-color: #fff !important;\n	color: #000 !important;\n	font-weight: 800 !important;\n	transition: all 0.2s ease-in-out;\n	display: flex;\n	align-items: center;\n	gap: 4px;\n\n	.blue {\n		color: #387cf6;\n	}\n\n	.beta {\n		background-color: #387cf6;\n		padding: 2px 4px;\n		border-radius: 4px;\n		display: flex;\n		align-items: center;\n		justify-content: center;\n		margin-left: 2px;\n\n		span {\n			font-weight: bold;\n			color: white;\n			font-size: 8px;\n			line-height: 8px;\n		}\n	}\n\n	&:hover {\n		background-color: #f0f5ff !important;\n		transform: scale(1.05);\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	background-color: #3D4148 !important;\n	color: #fff !important;\n	font-weight: 800 !important;\n	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n	margin-right: 8px;\n	padding: 6px 12px;\n	display: flex;\n	align-items: center;\n	gap: 6px;\n\n	.new-badge {\n		background-color: #387cf6;\n		color: white;\n		font-size: 8px;\n		font-weight: 900;\n		padding: 2px 4px;\n		border-radius: 4px;\n		line-height: 1;\n		display: flex;\n		align-items: center;\n		justify-content: center;\n	}\n\n	&:hover {\n		background-color: #4A4E57 !important;\n		transform: scale(1.05);\n		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	min-height: 56px;\n	padding: 26px 40px;\n	position: sticky;\n	background-color: var(--card-bg);\n	gap: 10px;\n	top: 0;\n	z-index: 10000;\n\n	@media (max-width: 1175px) {\n		.gnb-nav {\n			display: none;\n		}\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	background-color: var(--primary);\n	padding: 8px;\n	position: sticky;\n	top: 82px;\n	z-index: 10000;\n	cursor: pointer;\n\n	.text {\n		color: white;\n		font-size: 16px;\n		font-weight: 500;\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 110px;\n	margin-right: 32px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	min-width: fit-content;\n	width: fit-content;\n	padding: 0;\n	color: #fff;\n	text-align: center;\n	font-family: Pretendard;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 130%; /* 18.2px */\n	letter-spacing: -0.42px;\n	position: relative;\n\n	.beta {\n		background-color: var(--primary);\n		padding: 3px 8px;\n		border-radius: 20px;\n		display: flex;\n		flex-direction: row;\n		align-items: center;\n		justify-content: center;\n		margin-left: 5px;\n		margin-right: 0px;\n\n		div {\n			display: flex;\n			align-items: center;\n			justify-content: center;\n			font-weight: bold;\n			color: white;\n			font-size: 10px;\n			line-height: 10px;\n			text-align: center;\n			text-transform: none;\n		}\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	0%, 100% {\n		box-shadow: 0 3px 12px rgba(56, 124, 246, 0.35);\n	}\n	50% {\n		box-shadow: 0 0 0 6px rgba(56, 124, 246, 0.15), 0 3px 16px rgba(56, 124, 246, 0.55);\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	-webkit-appearance: none;\n	appearance: none;\n	display: inline-flex;\n	align-items: center;\n	justify-content: center;\n	background-color: var(--primary);\n	color: #fff;\n	border: none;\n	font-size: 16px;\n	font-weight: 800;\n	padding: 8px 22px;\n	border-radius: 100px;\n	cursor: pointer;\n	white-space: nowrap;\n	font-family: Pretendard, sans-serif;\n	letter-spacing: -0.3px;\n	line-height: 1.3;\n	animation: ",
        " 2.5s ease-in-out infinite;\n	transition: background-color 0.2s ease-in-out, transform 0.2s ease-in-out;\n\n	&:hover {\n		animation: none;\n		background-color: #2563eb;\n		transform: scale(1.04);\n		box-shadow: 0 5px 18px rgba(56, 124, 246, 0.5);\n	}\n\n	&:active {\n		transform: scale(0.98);\n	}\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}












var GnbButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_templateObject());
var HighlightButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(GnbButton)(_templateObject1());
var MenuBoardButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(GnbButton)(_templateObject2());
var MainGnbContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject3());
var MainGnb = function(props) {
    var type = props.type, noBanner = props.noBanner;
    var user = (0,_src_hook_useUser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), menuBoardOpen = ref[0], setMenuBoardOpen = ref[1];
    var onClickLoginClient = function() {
        router.push("/signin?type=client");
    };
    var onClickLoginExpert = function() {
        router.push("/signin?type=expert");
    };
    var onClickDashboard = function() {
        router.push("/match/my");
    };
    var onClickMenuBoard = function() {
        if (user.isLogin) {
            _src_api__WEBPACK_IMPORTED_MODULE_9__/* .apiServiceV2.post */ .sl.post("/utils/click-menu-board").catch(function(err) {
                return console.error(err);
            });
            window.open("https://shrouded-meal-521.notion.site/2aff8567bbfa8029809bc906e4277307?v=2aff8567bbfa80218222000cad0af51c", "_blank");
        } else {
            setMenuBoardOpen(true);
        }
    };
    var getRightContent = function() {
        if (type === "client") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_5__/* .GroupA */ .so, {
                    order: "row-center-between",
                    gap: 24,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DashboardCtaButton, {
                            onClick: onClickLoginClient,
                            children: "로그인하기"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GnbMenuButton, {
                            variant: "text",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                href: "/expert",
                                children: "전문가이신가요?"
                            })
                        })
                    ]
                })
            });
        } else if (type === "expert") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_5__/* .GroupA */ .so, {
                    order: "row-center-between",
                    gap: 36,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DashboardCtaButton, {
                            onClick: onClickLoginExpert,
                            children: "로그인하기"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GnbMenuButton, {
                            variant: "text",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                href: "/",
                                children: "고객사이신가요?"
                            })
                        })
                    ]
                })
            });
        }
        return null;
    };
    var highlightButton = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HighlightButton, {
        variant: "contained",
        onClick: function() {
            return window.open("https://notion.1point.kr/agency-matching", "_blank");
        },
        children: [
            "탑티어 ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "blue",
                children: "대행사"
            }),
            " 매칭받기",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "beta",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: "BETA"
                })
            })
        ]
    });
    var menuBoardButton = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MenuBoardButton, {
        variant: "contained",
        onClick: onClickMenuBoard,
        children: [
            "마케팅 메뉴판 확인하기",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "new-badge",
                children: "NEW"
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainGnbContainer, {
                className: "column-center-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "row-center-between",
                    style: {
                        width: "100%",
                        maxWidth: "1140px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_5__/* .GroupA */ .so, {
                            order: "row-center-between",
                            gap: 10,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        style: {
                                            width: "130px",
                                            marginRight: "32px"
                                        },
                                        src: "/onepoint/assets/images/logo/h-logo.png"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "gnb-nav",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_5__/* .GroupA */ .so, {
                                        order: "row-center-between",
                                        gap: 24,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GnbMenuButton, {
                                                variant: "text",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    href: "https://featpaper.com/l/JemyuEY9",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "서비스 소개"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GnbMenuButton, {
                                                variant: "text",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "hiring",
                                                    href: "https://1point.kr/blog",
                                                    children: "블로그"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GnbMenuButton, {
                                                variant: "text",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "hiring",
                                                    href: "https://1point.kr/blog/best-practices/",
                                                    children: "성공 사례"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GnbMenuButton, {
                                                variant: "text",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "hiring",
                                                    href: "/about",
                                                    children: "회사 소개"
                                                })
                                            }),
                                            type === "client" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_5__/* .GroupA */ .so, {
                                                order: "row-center-between",
                                                gap: 4,
                                                children: [
                                                    menuBoardButton,
                                                    highlightButton
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_5__/* .GroupA */ .so, {
                            order: "row-center-between",
                            children: user.isLogin ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DashboardCtaButton, {
                                    onClick: onClickDashboard,
                                    children: "대시보드 →"
                                })
                            }) : getRightContent()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_MarketingMenuBoardModal__WEBPACK_IMPORTED_MODULE_8__/* .MarketingMenuBoardModal */ .a, {
                open: menuBoardOpen,
                onClose: function() {
                    return setMenuBoardOpen(false);
                }
            }),
            type === "client" && !noBanner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Banner, {
                className: "row-center-between",
                id: "banner-close",
                onClick: function() {
                    window.open("https://docs.channel.io/onepoint/ko/articles/1286c10a-%EB%A6%AC%EC%8A%A4%ED%81%AC%ED%94%84%EB%A6%AC-%EC%A0%95%EC%B1%85-%EC%95%88%EB%82%B4");
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "text",
                        children: [
                            "\uD83C\uDF89리스크프리 프로그램!",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                style: {
                                    fontWeight: 800
                                },
                                children: "전문가 불만족시 100% 환불!"
                            }),
                            "✨"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        style: {
                            fill: "white",
                            cursor: "pointer",
                            width: "20px",
                            height: "20px"
                        },
                        onClick: function(e) {
                            e.stopPropagation();
                            document.getElementById("banner-close").style.display = "none";
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {})
        ]
    });
};
var Banner = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject4());
var GnbLogo = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img */ .Z.img(_templateObject5());
var GnbMenuButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_templateObject6());
var pulseGlow = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .keyframes */ .F4)(_templateObject7());
var DashboardCtaButton = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button */ .Z.button(_templateObject8(), pulseGlow);


/***/ }),

/***/ 63286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	min-width: 100vw;\n	min-height: 100vh;\n	background-color: #fff;\n	position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var MainLayout = function(props) {
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainLayoutContainer, {
        children: props.children
    });
};
var MainLayoutContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());


/***/ }),

/***/ 4547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ MarketingMenuBoardModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61953);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(54225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(23978);
/* harmony import */ var _src_ruix__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9869);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _src_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53249);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4480);
/* harmony import */ var _src_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51413);
/* harmony import */ var _src_utils_sign__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57386);














var MarketingMenuBoardModal = function(props) {
    var open = props.open, onClose = props.onClose;
    var isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("(max-width: 600px)");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var setSnackbarState = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_6__/* .globalSnackbarState */ .j8);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        name: "",
        companyName: "",
        email: ""
    }), formData = ref[0], setFormData = ref[1];
    var handleChange = function(e) {
        var _target = e.target, name = _target.name, value = _target.value;
        setFormData(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, name, value));
        });
    };
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!formData.name || !formData.companyName || !formData.email) {
                            setSnackbarState("모든 항목을 입력해주세요.");
                            return [
                                2
                            ];
                        }
                        if (!(0,_src_utils_sign__WEBPACK_IMPORTED_MODULE_13__/* .validateEmail */ .oH)(formData.email)) {
                            setSnackbarState("올바른 이메일 형식을 입력해주세요.");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _src_api__WEBPACK_IMPORTED_MODULE_3__/* .apiServiceV2.post */ .sl.post("/utils/click-menu-board-unauth", formData)
                        ];
                    case 2:
                        _state.sent();
                        window.open("https://shrouded-meal-521.notion.site/2aff8567bbfa8029809bc906e4277307?v=2aff8567bbfa80218222000cad0af51c", "_blank");
                        onClose();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        setSnackbarState("제출 중 오류가 발생했습니다.");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickLogin = function() {
        router.push("/signin?type=client");
        onClose();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_1__/* .ModalA */ .zk, {
        isOpen: open,
        onClose: onClose,
        maxWidth: "450px",
        bgColor: "white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            sx: {
                p: isMobile ? 2 : 4,
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    variant: "h5",
                    fontWeight: "bold",
                    sx: {
                        mb: 1
                    },
                    children: "원포인트 마케팅 메뉴판"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    variant: "body2",
                    color: "text.secondary",
                    sx: {
                        mb: 3
                    },
                    children: [
                        "성함, 고객사명, 이메일 주소를 입력하시면",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "마케팅 메뉴판 링크로 즉시 연결됩니다."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    sx: {
                        mb: 3,
                        p: 2,
                        bgcolor: "#f8f9fa",
                        borderRadius: 2
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            variant: "body2",
                            children: "이미 회원이신가요?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            variant: "body2",
                            sx: {
                                mb: 1
                            },
                            children: "로그인 후 메뉴판 확인하기 버튼을 클릭해주세요."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            variant: "outlined",
                            size: "small",
                            onClick: onClickLogin,
                            sx: {
                                fontWeight: "bold"
                            },
                            children: "로그인하기"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    fullWidth: true,
                    label: "성함",
                    name: "name",
                    variant: "outlined",
                    value: formData.name,
                    onChange: handleChange,
                    sx: {
                        mb: 2
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    fullWidth: true,
                    label: "고객사명",
                    name: "companyName",
                    variant: "outlined",
                    value: formData.companyName,
                    onChange: handleChange,
                    sx: {
                        mb: 2
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    fullWidth: true,
                    label: "이메일 주소",
                    name: "email",
                    variant: "outlined",
                    value: formData.email,
                    onChange: handleChange,
                    sx: {
                        mb: 3
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_1__/* .ButtonA */ .bx, {
                    fullWidth: true,
                    buttonClass: "primary",
                    size: "large",
                    sx: {
                        py: 1.5,
                        fontSize: "18px",
                        fontWeight: "bold"
                    },
                    onClick: handleSubmit,
                    children: "메뉴판 확인하기"
                })
            ]
        })
    });
};


/***/ })

}]);